/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type DreamScanRuleField =
  (typeof DreamScanRuleField)[keyof typeof DreamScanRuleField];

export const DreamScanRuleField = {
  client_tenant_id: "client_tenant_id",
  environment: "environment",
  traffic_type: "traffic_type",
  session_id: "session_id",
  initiated_by: "initiated_by",
} as const;
